import { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../redux/slices/authSlice";
import { useNavigate } from "react-router-dom";



const UserDropdown = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = useSelector((state) => state.auth.token);
  // const name = useSelector((state) => state.user);
  // console.log("The user name is :", name)

  const [open, setOpen] = useState(false);
  const dropdownRef = useRef();

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = async () => {
    try {
      await dispatch(logoutUser()).unwrap();
      navigate("/login"); // redirect after logout
    } catch (err) {
      console.error("Logout failed:", err);
    }
  };

  return (
    <div className="relative" ref={dropdownRef}>
      {/* Button styled as before */}
      <button
        onClick={() => setOpen(!open)}
        className="text-sm font-medium text-white cursor-pointer rounded-full w-8 h-8 bg-[#FF6943] flex items-center justify-center"
      >
        {/* Added the admin's A manually, after getting username in return in api will add dynamically */}
        A
      </button>

      {/* Dropdown menu */}
      {open && (
        <div className="absolute right-0 mt-1 w-32 bg-white  rounded-lg shadow-lg z-50">
          <button
            onClick={handleLogout}
            className="block px-4 py-2 text-sm w-32 text-black rounded-lg hover: bg-[#FF6943]/10 transition-colors ease-in-out duration-500 cursor-pointer"
          >
            Logout
          </button>
        </div>
      )}
    </div>
  );
};

export default UserDropdown;
